import React, { useState, useContext, useEffect, useRef } from "react";
import { Typography, Paper } from "@mui/material";
import { AppContext } from "../context/AppContext";
import PaymentBox from "../components/Checkout/PaymentBox";
import "./Checkout.css";

export default function Checkout() {
  const { cartItems, setCartItems } = useContext(AppContext);

  const [userData, setUserData] = useState({
    nombre: "",
    telefono: "",
    correo: "",
    aceptar: false
  });

  const [payphoneTxId, setPayphoneTxId] = useState("");
  const pollingStopRef = useRef(true);

  const newPayphoneTxId = () =>
    `ORD-${Date.now()}-${Math.random().toString(36).slice(2, 10).toUpperCase()}`;

  useEffect(() => {
    document.title = "Checkout | DR Soluciones Informáticas";
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const onMessage = (e) => {
      const msg = e.data;
      if (!msg || typeof msg !== "object") return;
      if (msg.type === "PP_ERROR" && msg.code === "DUPLICATE_TXID") {
        const fresh = newPayphoneTxId();
        setPayphoneTxId(fresh);
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  const handleUserChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="container py-4">
      <div className="row g-4">

        <div className="col-12 col-lg-6">
          <Paper sx={{ p: 3, backgroundColor: "#fff", borderRadius: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#0A3D91" }}>
              Tus Datos
            </Typography>

            <div className="privacidad-info" style={{ marginTop: "1rem" }}>
              Todos los campos con (*) son obligatorios.
            </div>

            <div className="select-group">
              <label htmlFor="nombre">Nombre *</label>
              <input
                id="nombre"
                name="nombre"
                type="text"
                value={userData.nombre}
                onChange={handleUserChange}
              />
            </div>

            <div className="select-group">
              <label htmlFor="telefono">Teléfono *</label>
              <input
                id="telefono"
                name="telefono"
                type="text"
                value={userData.telefono}
                onChange={handleUserChange}
              />
            </div>

            <div className="select-group">
              <label htmlFor="correo">Correo (opcional)</label>
              <input
                id="correo"
                name="correo"
                type="email"
                value={userData.correo}
                onChange={handleUserChange}
              />
            </div>
          </Paper>
        </div>

        <div className="col-12 col-lg-6">
          <Paper sx={{ p: 3, backgroundColor: "#fff", borderRadius: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color:"#0A3D91" }}>
              Resumen del Pedido
            </Typography>

            {cartItems.map((item, idx) => {
              const unit = Number(item.price_with_iva ?? item.price ?? 0);
              return (
                <div key={idx} style={{ marginBottom: "1rem" }}>
                  <Typography sx={{ fontWeight: 700 }}>
                    {item.quantity}× {item.name}
                  </Typography>
                  <Typography>
                    Marca: {item.brand || item.marca || "Sin marca"}
                  </Typography>
                  <Typography>
                    Referencia: {item.code || item.ref || "N/A"}
                  </Typography>
                  <Typography sx={{ fontWeight: 700 }}>
                    ${unit.toFixed(2)}
                  </Typography>
                  <hr />
                </div>
              );
            })}

            <PaymentBox
              cartItems={cartItems}
              setCartItems={setCartItems}
              userData={userData}
              setUserData={setUserData}
              payphoneTxId={payphoneTxId}
              setPayphoneTxId={setPayphoneTxId}
              newPayphoneTxId={newPayphoneTxId}
              pollingStopRef={pollingStopRef}
            />
          </Paper>
        </div>

      </div>
    </div>
  );
}
